import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue)

    // Visual feedback
    const span = this.element.querySelector("span")
    if (span) {
      const original = span.textContent
      span.textContent = "Link copiado!"
      setTimeout(() => { span.textContent = original }, 2000)
    }
  }
}
